export const rAF = (fn) => window.requestAnimationFrame(fn)
export const cAF = handle => window.cancelAnimationFrame(handle)



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/utils/raf.js